import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './AccountPage.css';

const AccountPage = ({ onNavigate }) => {
  const { user } = useAuth();
  const [activeSection, setActiveSection] = useState('profile');


  // Check for section from sessionStorage on component mount
  useEffect(() => {
    const savedSection = sessionStorage.getItem('activeAccountSection');
    
    if (savedSection) {
      setActiveSection(savedSection);
      // Clear the sessionStorage after using it
      sessionStorage.removeItem('activeAccountSection');
    }
  }, []);

  // Listen for storage changes to handle menu clicks when already on account page
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'activeAccountSection' && e.newValue) {
        setActiveSection(e.newValue);
        sessionStorage.removeItem('activeAccountSection');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also check for changes periodically (fallback)
    const interval = setInterval(() => {
      const savedSection = sessionStorage.getItem('activeAccountSection');
      if (savedSection) {
        setActiveSection(savedSection);
        sessionStorage.removeItem('activeAccountSection');
      }
    }, 100);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);
  const [formData, setFormData] = useState({
    username: user?.displayName || 'joyjukebox',
    email: user?.email || 'livesta.app@gmail.com',
    password: '************',
    bio: 'joyjukeboxjoyjukeboxjoyjukeboxjoyjukeboxjoyjukeboxjoyjukebox',
    preferredLanguage: 'English',
    links: {
      general: '',
      cloud: '',
      streaming: '',
      youtube: '',
      instagram: ''
    }
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleLinkChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      links: {
        ...prev.links,
        [name]: value
      }
    }));
  };

  const handleSave = () => {
    console.log('Saving profile data:', formData);
  };

  const handleBackClick = () => {
    onNavigate('home');
  };

  // const toggleSection = (section) => {
  //   setActiveSection(activeSection === section ? null : section);
  // };

  // Sample data for different sections
  const ticketsData = [
    {
      id: 1,
      event: 'Fiona - We Are The Universe',
      date: '2025.09.22',
      time: '7:00 PM',
      venue: 'BBCB, Itaewon',
      status: 'Confirmed',
      qrCode: 'QR123456'
    },
    {
      id: 2,
      event: 'Alex - Neon Dreams',
      date: '2025.10.15',
      time: '8:00 PM',
      venue: 'Club Octagon, Gangnam',
      status: 'Confirmed',
      qrCode: 'QR789012'
    }
  ];

  const messagesData = [
    {
      id: 1,
      sender: 'Fiona Official',
      subject: 'Concert Update',
      preview: 'Thank you for your support! Here are the latest updates...',
      time: '2 hours ago',
      unread: true
    },
    {
      id: 2,
      sender: 'LIVESTA Support',
      subject: 'Welcome to LIVESTA',
      preview: 'Welcome to our platform! We hope you enjoy...',
      time: '1 day ago',
      unread: false
    }
  ];

  const notificationSettings = {
    email: {
      concertUpdates: true,
      newReleases: true,
      promotions: false,
      newsletters: true
    },
    push: {
      concertReminders: true,
      newMessages: true,
      friendActivity: false,
      systemUpdates: true
    }
  };

  const paymentMethods = [
    {
      id: 1,
      type: 'Credit Card',
      last4: '**** **** **** 1234',
      expiry: '12/25',
      isDefault: true
    },
    {
      id: 2,
      type: 'PayPal',
      email: 'user@example.com',
      isDefault: false
    }
  ];

  return (
    <div className="my-account-page">
      <div className="account-container">
        <div className="account-header">
          <div className="header-top">
            <button className="back-button" onClick={handleBackClick}>
              <i className="fas fa-arrow-left"></i>
              Back to Home
            </button>
          </div>
          <h1 className="account-title">My Account</h1>
          <div className="title-line"></div>
        </div>

        <div className="account-layout">
          {/* Left Sidebar Navigation */}
          <div className="account-sidebar">
            <div className="sidebar-navigation">
              <button 
                className={`sidebar-nav-item ${activeSection === 'profile' ? 'active' : ''}`}
                onClick={() => setActiveSection('profile')}
              >
                <i className="fas fa-user"></i>
                <span>Profile</span>
              </button>

              <button 
                className={`sidebar-nav-item ${activeSection === 'tickets' ? 'active' : ''}`}
                onClick={() => setActiveSection('tickets')}
              >
                <i className="fas fa-ticket-alt"></i>
                <span>My Tickets</span>
              </button>

              <button 
                className={`sidebar-nav-item ${activeSection === 'notifications' ? 'active' : ''}`}
                onClick={() => setActiveSection('notifications')}
              >
                <i className="fas fa-bell"></i>
                <span>Notifications</span>
              </button>

              <button 
                className={`sidebar-nav-item ${activeSection === 'messages' ? 'active' : ''}`}
                onClick={() => setActiveSection('messages')}
              >
                <i className="fas fa-comments"></i>
                <span>Messages</span>
              </button>

              <button 
                className={`sidebar-nav-item ${activeSection === 'settings' ? 'active' : ''}`}
                onClick={() => setActiveSection('settings')}
              >
                <i className="fas fa-cog"></i>
                <span>Settings</span>
              </button>
            </div>
          </div>

          {/* Right Content Area */}
          <div className="account-main-content">
          {/* Profile Section */}
          {activeSection === 'profile' && (
            <div className="account-section">
              <div className="section-header">
                <h2 className="section-title">Profile Information</h2>
              </div>
              <div className="section-content">
                <div className="profile-sections">
                  <div className="profile-section">
                    <label className="section-label">Username (can't be changed)</label>
                    <div className="section-value">{formData.username}</div>
                  </div>

                  <div className="profile-section">
                    <label className="section-label">Email Address</label>
                    <div className="section-value">{formData.email}</div>
                  </div>

                  <div className="profile-section">
                    <label className="section-label">Password</label>
                    <div className="section-value">{formData.password}</div>
                  </div>

                  <div className="profile-section">
                    <label className="section-label">Bio</label>
                    <textarea
                      className="section-textarea"
                      value={formData.bio}
                      onChange={handleInputChange}
                      name="bio"
                      rows="2"
                    />
                  </div>

                  <div className="profile-section">
                    <label className="section-label">Preferred Language</label>
                    <select
                      className="section-select"
                      value={formData.preferredLanguage}
                      onChange={handleInputChange}
                      name="preferredLanguage"
                    >
                      <option value="English">English</option>
                      <option value="Korean">Korean</option>
                      <option value="Japanese">Japanese</option>
                      <option value="Chinese">Chinese</option>
                    </select>
                  </div>

                  <div className="profile-section">
                    <label className="section-label">Links</label>
                    <div className="links-container">
                      <div className="link-item">
                        <i className="fas fa-link"></i>
                        <input
                          type="text"
                          className="link-input"
                          placeholder="General Link"
                          value={formData.links.general}
                          onChange={handleLinkChange}
                          name="general"
                        />
                      </div>
                      <div className="link-item">
                        <i className="fas fa-cloud"></i>
                        <input
                          type="text"
                          className="link-input"
                          placeholder="Cloud Link"
                          value={formData.links.cloud}
                          onChange={handleLinkChange}
                          name="cloud"
                        />
                      </div>
                      <div className="link-item">
                        <i className="fas fa-music"></i>
                        <input
                          type="text"
                          className="link-input"
                          placeholder="Streaming Platform"
                          value={formData.links.streaming}
                          onChange={handleLinkChange}
                          name="streaming"
                        />
                      </div>
                      <div className="link-item">
                        <i className="fab fa-youtube"></i>
                        <input
                          type="text"
                          className="link-input"
                          placeholder="YouTube"
                          value={formData.links.youtube}
                          onChange={handleLinkChange}
                          name="youtube"
                        />
                      </div>
                      <div className="link-item">
                        <i className="fab fa-instagram"></i>
                        <input
                          type="text"
                          className="link-input"
                          placeholder="Instagram"
                          value={formData.links.instagram}
                          onChange={handleLinkChange}
                          name="instagram"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="change-button-container">
                  <button className="change-button" onClick={handleSave}>
                    CHANGE
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* My Tickets Section */}
          {activeSection === 'tickets' && (
            <div className="account-section">
              <div className="section-header">
                <h2 className="section-title">My Tickets</h2>
              </div>
              <div className="section-content">
                <div className="tickets-grid">
                  {ticketsData.map(ticket => (
                    <div key={ticket.id} className="ticket-card">
                      <div className="ticket-header">
                        <h3 className="ticket-event">{ticket.event}</h3>
                        <span className={`ticket-status ${ticket.status.toLowerCase()}`}>
                          {ticket.status}
                        </span>
                      </div>
                      <div className="ticket-details">
                        <div className="ticket-info">
                          <i className="fas fa-calendar"></i>
                          <span>{ticket.date} at {ticket.time}</span>
                        </div>
                        <div className="ticket-info">
                          <i className="fas fa-map-marker-alt"></i>
                          <span>{ticket.venue}</span>
                        </div>
                        <div className="ticket-info">
                          <i className="fas fa-qrcode"></i>
                          <span>QR Code: {ticket.qrCode}</span>
                        </div>
                      </div>
                      <div className="ticket-actions">
                        <button className="ticket-btn primary">View Details</button>
                        <button className="ticket-btn secondary">Download</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Notifications Section */}
          {activeSection === 'notifications' && (
            <div className="account-section">
              <div className="section-header">
                <h2 className="section-title">Notification Settings</h2>
              </div>
              <div className="section-content">
                <div className="notification-settings-content">
                  <div className="notification-category">
                    <h3 className="subsection-title">Email Notifications</h3>
                    <div className="notification-options">
                      <div className="notification-option">
                        <label>Concert Updates</label>
                        <div className="toggle-switch">
                          <input 
                            type="checkbox" 
                            checked={notificationSettings.email.concertUpdates}
                            readOnly
                          />
                          <span className="slider"></span>
                        </div>
                      </div>
                      <div className="notification-option">
                        <label>New Releases</label>
                        <div className="toggle-switch">
                          <input 
                            type="checkbox" 
                            checked={notificationSettings.email.newReleases}
                            readOnly
                          />
                          <span className="slider"></span>
                        </div>
                      </div>
                      <div className="notification-option">
                        <label>Promotions</label>
                        <div className="toggle-switch">
                          <input 
                            type="checkbox" 
                            checked={notificationSettings.email.promotions}
                            readOnly
                          />
                          <span className="slider"></span>
                        </div>
                      </div>
                      <div className="notification-option">
                        <label>Newsletters</label>
                        <div className="toggle-switch">
                          <input 
                            type="checkbox" 
                            checked={notificationSettings.email.newsletters}
                            readOnly
                          />
                          <span className="slider"></span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="notification-category">
                    <h3 className="subsection-title">Push Notifications</h3>
                    <div className="notification-options">
                      <div className="notification-option">
                        <label>Concert Reminders</label>
                        <div className="toggle-switch">
                          <input 
                            type="checkbox" 
                            checked={notificationSettings.push.concertReminders}
                            readOnly
                          />
                          <span className="slider"></span>
                        </div>
                      </div>
                      <div className="notification-option">
                        <label>New Messages</label>
                        <div className="toggle-switch">
                          <input 
                            type="checkbox" 
                            checked={notificationSettings.push.newMessages}
                            readOnly
                          />
                          <span className="slider"></span>
                        </div>
                      </div>
                      <div className="notification-option">
                        <label>Friend Activity</label>
                        <div className="toggle-switch">
                          <input 
                            type="checkbox" 
                            checked={notificationSettings.push.friendActivity}
                            readOnly
                          />
                          <span className="slider"></span>
                        </div>
                      </div>
                      <div className="notification-option">
                        <label>System Updates</label>
                        <div className="toggle-switch">
                          <input 
                            type="checkbox" 
                            checked={notificationSettings.push.systemUpdates}
                            readOnly
                          />
                          <span className="slider"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Messages Section */}
          {activeSection === 'messages' && (
            <div className="account-section">
              <div className="section-header">
                <h2 className="section-title">Messages</h2>
              </div>
              <div className="section-content">
                <div className="messages-list">
                  {messagesData.map(message => (
                    <div key={message.id} className={`message-item ${message.unread ? 'unread' : ''}`}>
                      <div className="message-avatar">
                        <i className="fas fa-user"></i>
                      </div>
                      <div className="message-content">
                        <div className="message-header">
                          <h4 className="message-sender">{message.sender}</h4>
                          <span className="message-time">{message.time}</span>
                        </div>
                        <h5 className="message-subject">{message.subject}</h5>
                        <p className="message-preview">{message.preview}</p>
                      </div>
                      {message.unread && <div className="unread-indicator"></div>}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Settings Section */}
          {activeSection === 'settings' && (
            <div className="account-section">
              <div className="section-header">
                <h2 className="section-title">Settings</h2>
              </div>
              <div className="section-content">
                <div className="settings-content">
                  <div className="settings-category">
                    <h3 className="subsection-title">Payment Methods</h3>
                    <div className="payment-methods">
                      {paymentMethods.map(method => (
                        <div key={method.id} className={`payment-method ${method.isDefault ? 'default' : ''}`}>
                          <div className="payment-info">
                            <i className={`fas fa-${method.type === 'Credit Card' ? 'credit-card' : 'paypal'}`}></i>
                            <div className="payment-details">
                              <span className="payment-type">{method.type}</span>
                              <span className="payment-number">
                                {method.last4 || method.email}
                              </span>
                            </div>
                          </div>
                          <div className="payment-actions">
                            {method.isDefault && <span className="default-badge">Default</span>}
                            <button className="payment-btn">Edit</button>
                          </div>
                        </div>
                      ))}
                      <button className="add-payment-btn">
                        <i className="fas fa-plus"></i>
                        Add Payment Method
                      </button>
                    </div>
                  </div>

                  <div className="settings-category">
                    <h3 className="subsection-title">Account Security</h3>
                    <div className="security-options">
                      <div className="security-option">
                        <div className="security-info">
                          <i className="fas fa-shield-alt"></i>
                          <div>
                            <h4>Two-Factor Authentication</h4>
                            <p>Add an extra layer of security to your account</p>
                          </div>
                        </div>
                        <button className="security-btn">Enable</button>
                      </div>
                      <div className="security-option">
                        <div className="security-info">
                          <i className="fas fa-key"></i>
                          <div>
                            <h4>Change Password</h4>
                            <p>Update your password regularly</p>
                          </div>
                        </div>
                        <button className="security-btn">Change</button>
                      </div>
                    </div>
                  </div>

                  <div className="settings-category">
                    <h3 className="subsection-title">Privacy</h3>
                    <div className="privacy-options">
                      <div className="privacy-option">
                        <label>Profile Visibility</label>
                        <select className="privacy-select">
                          <option value="public">Public</option>
                          <option value="friends">Friends Only</option>
                          <option value="private">Private</option>
                        </select>
                      </div>
                      <div className="privacy-option">
                        <label>Activity Status</label>
                        <select className="privacy-select">
                          <option value="visible">Visible to Friends</option>
                          <option value="hidden">Hidden</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountPage;


